import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-center h-16 px-4 md:px-6">
        <h1 className="text-sm md:text-base font-medium text-foreground-800 tracking-wide whitespace-nowrap font-heading">
          (ADVNET DIGITAL, UAB)
        </h1>
      </div>
    </header>
  );
}